import * as joint from '@joint/core'

/**
 * C4 Person shape - humanoid figure with head and body
 */
export const C4Person = joint.dia.Element.define(
  'c4.Person',
  {
    size: { width: 200, height: 220 },
    attrs: {
      body: {
        refX: '50%',
        refY: 70,
        refWidth: '70%',
        refHeight: 150,
        rx: 20,
        ry: 20,
        fill: '#08427b',
        stroke: '#052e56',
        strokeWidth: 2,
        transform: 'translate(-70, 0)',
      },
      head: {
        refX: '50%',
        refY: 35,
        r: 35,
        fill: '#08427b',
        stroke: '#052e56',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: 110,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 130,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Person]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 160,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '80%',
          height: 60,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'circle',
        selector: 'head',
      },
      {
        tagName: 'text',
        selector: 'nameLabel',
      },
      {
        tagName: 'text',
        selector: 'typeLabel',
      },
      {
        tagName: 'text',
        selector: 'descriptionLabel',
      },
    ],
  }
)

export function createPerson(
  id: string,
  name: string,
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const person = new C4Person({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      head: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return person
}
